import "./globalCapabilityWorkflow.css";

const workflowSteps = [
  {
    number: "01",
    label: "STEP ONE",
    title: "Understand",
    description:
      "Discuss your business goals, scope, workflows, and success criteria.",
  },
  {
    number: "02",
    label: "STEP TWO",
    title: "Define",
    description:
      "Agree on the service model, responsibilities, communication, and delivery expectations.",
  },
  {
    number: "03",
    label: "STEP THREE",
    title: "Deliver",
    description:
      "Set up the agreed team or process and begin delivery against the defined scope.",
  },
  {
    number: "04",
    label: "STEP FOUR",
    title: "Review",
    description:
      "Review outcomes and identify adjustments based on business needs.",
  },
];

export default function GlobalCapabilityWorkflow() {
  return (
    <section className="gc-workflow-journey">
      <div className="gc-workflow-journey__container">
        <header className="gc-workflow-journey__header">
          <span className="gc-workflow-journey__eyebrow">
            <span
              className="gc-workflow-journey__eyebrow-dot"
              aria-hidden="true"
            />
            HOW WE WORK
          </span>

          <div className="gc-workflow-journey__heading-row">
            <h2 className="gc-workflow-journey__title">
              A Clear Path from
              <br />
              <span>Planning to Delivery.</span>
            </h2>

            <p className="gc-workflow-journey__intro">
              A structured approach that aligns people, processes, and
              expectations with your business needs.
            </p>
          </div>
        </header>

        <div className="gc-workflow-journey__timeline">
          {workflowSteps.map((step, index) => (
            <article
              className="gc-workflow-journey__step"
              key={step.number}
              style={{ "--step-index": index }}
            >
              <div className="gc-workflow-journey__step-index">
                <span className="gc-workflow-journey__step-label">
                  {step.label}
                </span>

                <span className="gc-workflow-journey__step-number">
                  {step.number}
                </span>
              </div>

              <div className="gc-workflow-journey__step-indicator">
                <span className="gc-workflow-journey__step-dot" />
              </div>

              <div className="gc-workflow-journey__step-content">
                <h3 className="gc-workflow-journey__step-title">
                  {step.title}
                  <span
                    className="gc-workflow-journey__step-arrow"
                    aria-hidden="true"
                  >
                    ↗
                  </span>
                </h3>

                <p className="gc-workflow-journey__step-description">
                  {step.description}
                </p>
              </div>
            </article>
          ))}
        </div>

        <div className="gc-workflow-journey__footer">
          <span
            className="gc-workflow-journey__footer-line"
            aria-hidden="true"
          />

          <p>
            Clear expectations. Structured execution. Continuous improvement.
          </p>
        </div>
      </div>
    </section>
  );
}
